import { injectable } from 'inversify';
import { TeamRepository } from '../../../state/reduxRepositories';
import { Team } from '../../../state/reduxRepositories/teams/team.interfaces';
import { useAppSelector } from '../../../state/hooks';
import { Alert } from '../../../state/reduxRepositories/selectors.interface';

@injectable()
export class ManageTeamDomainService {
  constructor(private teamRepository: TeamRepository) {}
  dispatchUpdateTeam = (team: Team): void => {
    this.teamRepository.dispatchUpdate(team);
  };
  dispatchAddTeam = (teamName: string): void => {
    this.teamRepository.dispatchCreate({ name: teamName });
  };

  useAllTeamsListSelector = (): Team[] => {
    return useAppSelector(this.teamRepository.selectors.resourcesSelector);
  };

  useTeamUpdateLoaderSelector = (): boolean => {
    return useAppSelector(this.teamRepository.selectors.isLoadingSelector);
  };
}
